import { IdTitle, IIdTitle } from "./idTitle";

export interface IIdTitleClass extends IIdTitle {
    classes: string;

    getHash(): string;
}

export class IdTitleClass extends IdTitle implements IIdTitleClass {
    classes: string;

    constructor();
    constructor(obj: IIdTitleClass);
    constructor(obj?: any) {
        super(obj);
        this.classes = obj && obj.classes || "";
    }

    getHash(): string {
        return super.getHash() + "#" + this.classes;
    }

    static createIdTitleClass(id: string, title: string, classes: string): IIdTitleClass {
        const result = new IdTitleClass();
        result.id = id;
        result.title = title;
        result.classes = classes;
        return result;
    }
}